import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

export default function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="aspectly:min-h-screen aspectly:flex aspectly:flex-col aspectly:bg-surface aspectly:font-body aspectly:text-on-surface">
      {/* Top nav (minimal) */}
      <nav className="aspectly:w-full aspectly:flex aspectly:justify-between aspectly:items-center aspectly:px-8 aspectly:py-4 aspectly:fixed aspectly:top-0 aspectly:z-50 aspectly:bg-surface">
        <Link
          to="/"
          className="aspectly:flex aspectly:items-center aspectly:cursor-pointer aspectly:hover:opacity-90 aspectly:transition-opacity"
        >
          <img
            src="/aspectly-logo-horizontal.svg"
            alt="Aspectly"
            className="aspectly:h-9 aspectly:w-auto aspectly:max-w-[180px] aspectly:object-contain aspectly:shrink-0"
          />
        </Link>
        <div className="aspectly:flex aspectly:items-center aspectly:gap-6">
          <a
            className="aspectly:text-sm aspectly:font-medium aspectly:tracking-wide aspectly:text-on-surface-variant aspectly:hover:text-primary aspectly:transition-colors"
            href="#"
          >
            Sign Up
          </a>
        </div>
      </nav>

      {/* Content */}
      <main className="aspectly:grow aspectly:flex aspectly:items-center aspectly:justify-center aspectly:pt-16 aspectly:pb-24 aspectly:px-6">
        {children}
      </main>

      {/* Footer */}
      <footer className="aspectly:w-full aspectly:flex aspectly:flex-col aspectly:md:flex-row aspectly:justify-between aspectly:items-center aspectly:px-8 aspectly:py-6 aspectly:border-t aspectly:border-outline-variant/20 aspectly:bg-surface">
        <div className="aspectly:text-xs aspectly:text-on-surface-variant aspectly:mb-4 aspectly:md:mb-0">
          © {new Date().getFullYear()} Aspectly.ai. All rights reserved.
        </div>
        <div className="aspectly:flex aspectly:gap-8">
          {['Privacy Policy', 'Terms of Service', 'Help Center', 'Contact'].map((label) => (
            <a
              key={label}
              className="aspectly:text-xs aspectly:text-on-surface-variant aspectly:hover:text-primary aspectly:transition-opacity aspectly:duration-200"
              href="#"
            >
              {label}
            </a>
          ))}
        </div>
      </footer>
    </div>
  );
}
